import { html } from "../../render";
import { attr, cn, numberToPxValue, spreadAttrs, styleVars, } from "../../utils";
export const LP_SKELETON_LINE_DEFAULTS = {
    width: 75,
    duration: 1.5,
    delay: 0,
};
const skeletonLineManagedAttrs = [
    "data-lp-component",
    "class",
    "style",
    "aria-hidden",
];
export function LpSkeletonLine({ width = LP_SKELETON_LINE_DEFAULTS.width, duration = LP_SKELETON_LINE_DEFAULTS.duration, delay = LP_SKELETON_LINE_DEFAULTS.delay, blockHeight, className, attributes, } = {}) {
    const lineStyle = [
        styleVars({
            "--lp-skeleton-line-width": `${Math.min(100, Math.max(0, width))}%`,
            "--lp-skeleton-line-duration": `${Math.max(0, duration)}s`,
            "--lp-skeleton-line-delay": `${Math.max(0, delay)}s`,
        }),
        typeof attributes?.style === "string" ? attributes.style : undefined,
    ].filter(Boolean).join(" ");
    const line = html `
        <div
            data-lp-component="SkeletonLine"
            class="${cn("lp-skeleton-line", className, attributes?.class)}"
            ${attr("style", lineStyle)}
            aria-hidden="true"
            ${spreadAttrs(attributes, { omit: skeletonLineManagedAttrs })}
        ></div>
    `;
    const blockSize = numberToPxValue(blockHeight);
    if (!blockSize) {
        return line;
    }
    return html `
        <div
            class="lp-skeleton-line_block"
            ${attr("style", styleVars({ "--lp-skeleton-line-block-size": blockSize }))}
        >
            ${line}
        </div>
    `;
}
